import { Injectable, inject } from "@angular/core";
import { ResourceFactMappingPatternEntry } from "@app/models/rest/resource-fact-mapping-pattern-entry";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { ResourceFactMappingPatternEntryRestService } from "@app/services/hal/resource-fact-mapping-pattern-entry-rest.service";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";

@Injectable({
  providedIn: "root"
})
export class MappingPatternEntryStore extends RealTimeDataStore<ResourceFactMappingPatternEntry> {
  constructor() {
    const resourceFactMappingPatternEntryRestService = inject(
      ResourceFactMappingPatternEntryRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      resourceFactMappingPatternEntryRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("ResourceFactMappingPatternEntry");
  }

  // Creates a pattern entry for a specific mapping pattern
  createEntryForPattern(
    pattern: ResourceFactMappingPattern,
    entry: ResourceFactMappingPatternEntry
  ) {
    // Set the pattern reference before saving
    entry.mappingPattern = pattern;
    return this.create(entry);
  }

  // Update an existing pattern entry
  updateEntry(entry: ResourceFactMappingPatternEntry) {
    return this.update(entry);
  }

  // Delete a pattern entry
  deleteEntry(entry: ResourceFactMappingPatternEntry) {
    return this.delete(entry);
  }
}
